import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { GetVariants, SaveVariant, DeleteVariant } from "../Api/variant_api";
import { ServiceQueryOptions, unwrapApiResponse } from "./query_helpers";
import { LOOKUP_STALE_TIME } from "../Constant/AppConstants";

export const variantQueryKeys = {
  variants: () => ["variants"] as const,
};

export const invalidateVariantQueries = (queryClient: any) => {
  queryClient.invalidateQueries({ queryKey: ["variants"] });
  queryClient.invalidateQueries({ queryKey: ["variations"] });
};

export const useVariantsQuery = (options?: ServiceQueryOptions) => {
  return useQuery({
    staleTime: LOOKUP_STALE_TIME,
    ...options,
    queryKey: variantQueryKeys.variants(),
    queryFn: async () => unwrapApiResponse(await GetVariants()),
  });
};

export const useSaveVariantMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: { id?: string; variant_name: string; variant_types: any[] }) =>
      SaveVariant(payload),
    onSuccess: () => {
      invalidateVariantQueries(queryClient);
    },
  });
};

export const useDeleteVariantMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => DeleteVariant(id),
    onSuccess: () => {
      invalidateVariantQueries(queryClient);
    },
  });
};